import styled from 'styled-components';

import { Card, token } from '@zillow/constellation';

export const StyledTourCard = styled(Card)`
  border-left: 3px solid ${token('colors.brand')};
  cursor: pointer;

  &:hover {
    border: 1px solid #006aff;
  }
`;
